<template>

  <div class="machine-maps" style="
      position: absolute;
      top: 0;
      width: 98%;
      height: 95%;
      background-color: white;
      padding: 1%;
      border-radius: 10px;
    " v-loading="fullscreenLoading">


    <div class="">
      <div class="machine-address">
        <el-table v-loading="loading" empty-text="No Data Found" :element-loading-text="'common.loading'"
          :data="machineListWithOperationType" style="width: 100%" max-height="720" :border="false"
          @sort-change="handleSortChange">
          <el-table-column :border="false" prop="name" :show-overflow-tooltip="true" label="Machine Name" width="130"
            :align="'left'"></el-table-column>
          <el-table-column prop="location" label="Address" width="130" :align="'left'" sortable="custom">
            <template slot-scope="scope">
              <span :class="scope.row.location ? '' : 'text-danger'" style="white-space:normal;word-break:break-word;">
                {{ scope.row.location ? cleanAddress(scope.row.location) : 'No Address' }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="Operation" width="110" :align="'center'" prop="operationType">
            <template slot-scope="scope">
              <el-link type="primary" style="white-space:normal;word-break:break-word;"
                @click="openAddressDialog(scope.row)">
                Edit
              </el-link>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-dialog class="location-dialog" :modal-append-to-body="true" :append-to-body="true"
        :visible.sync="addressDialogVisible" width="750px">
        <span slot="title" class="dialog-title-left">Location Details</span>
        <div class="popup-form">
          <el-form :model="addressForm">

            <el-row class="popup-row">
              <el-col :span="7" class="popup-label">Address</el-col>
              <el-col :span="17" class="popup-field">
                <el-autocomplete ref="addressAutocomplete" v-model="addressForm.location"
                  :fetch-suggestions="querySearch" placeholder="Enter" @select="handleAddressSelect"
                  style="width: 100%;" popper-class="address-suggestion-dropdown">
                  <template slot="prefix">
                    <i class="el-icon-search ip-icon" style="margin-right: 4px;"></i>
                  </template>
                  <template slot="suffix">
                    <i v-if="addressForm.location" class="el-icon-close ip-icon" @click="clearAddress"
                      style="cursor:pointer;"></i>
                  </template>
                  <template slot-scope="{ item }">
                    <div class="address-suggestion-item">
                      <span class="location-icon-bg">
                        <i class="el-icon-location"></i>
                      </span>
                      <div class="suggestion-text">
                        <div class="suggestion-title">{{ item.name }}</div>
                        <div class="suggestion-address">
                          <span v-if="item.county" style="color:#409EFF;font-weight:500;margin-right:6px;">{{
                            item.county }}</span>
                          {{ item.address }}
                        </div>
                      </div>
                    </div>
                  </template>
                </el-autocomplete>
              </el-col>
            </el-row>
            <el-row class="popup-row">
              <el-col :span="7" class="popup-label">Contact Person</el-col>
              <el-col :span="17" class="popup-field"><el-input v-model="addressForm.Contact"
                  placeholder="Enter" /></el-col>
            </el-row>
            <el-row class="popup-row">
              <el-col :span="7" class="popup-label">Installed Date</el-col>
              <el-col :span="17" class="popup-field"><el-date-picker v-model="addressForm.Installed" type="date"
                  value-format="yyyy-MM-dd" placeholder="Select date and time" style="width:100%;" /></el-col>
            </el-row>
            <el-row class="popup-row">
              <el-col :span="7" class="popup-label">Notes</el-col>
              <el-col :span="17" class="popup-field"><el-input type="textarea" v-model="addressForm.Notes"
                  placeholder="Enter" /></el-col>
            </el-row>
          </el-form>
          <el-row class="popup-row">
            <el-col :span="7" class="popup-label">Phone Number</el-col>
            <el-col :span="17" class="popup-field"><el-input v-model="addressForm.PhoneNumber"
                placeholder="Enter" /></el-col>
          </el-row>
          <el-row class="popup-row">
            <el-col :span="7" class="popup-label">Email</el-col>
            <el-col :span="17" class="popup-field"><el-input v-model="addressForm.email" placeholder="Enter" /></el-col>
          </el-row>
        </div>
        <div slot="footer" class="dialog-footer-left">
          <el-button type="primary" @click="saveAddress">Save</el-button>
          <el-button @click="addressDialogVisible = false">Cancel</el-button>
        </div>
      </el-dialog>
    </div>



    <div id="mapBox" style="width: 100%; height: 100%; text-align: center">
      {{ $t("user.MachineMaps.588934-0") }}
    </div>

  </div>
</template>
<script>
import { Loader } from "@googlemaps/js-api-loader";
import { MarkerClusterer } from "@googlemaps/markerclusterer";
import eventBus from "@/utils/eventBus";
let marker = null;
let positions = [];
export default {
  name: "MachineMaps",
  data() {
    return {
      machineList: [],
      seletedLocale: "",
      addressDialogVisible: false,
      addressDialogAction: 'add', // 'add' or 'edit'
      notesContentAction: 'add', // 'add' or 'edit'
      markerClusterer: null, // Store the marker clusterer instance
      mapInstance: null, // Store the Google Maps instance
      addressForm: {
        name: '',
        location: '',
        Contact: '',
        Installed: '',
        Notes: '',
        PhoneNumber: '',
        email: '',
        machineNo: '',
        notesId: '',  // to store the id of the notes when editing
        lat: '',
        lng: ''
      },
      selectedAddress: {},
      addressSuggestions: [],
      editingIndex: null,
      longitude: "",
      latitude: "",
      fullscreenLoading: false,
      rightLoading: true,
      table: false,
      search: {
        equipmentNo: "",
        equipmentName: ""
      },
      pageIndex: 1,
      pageSize: 10,
      showPositions: [],
      count: 0,
      isShow: false,
      control: {
        remoteCode: "",
        remoteId: "",
        remoteStatus: 0,
        url: ""
      },
      //  开锁验证
      dialogSmsVisible: false,
      issend: false,
      smscode: "",
      smsloading: false,
      miao: 180,
      verifytype: "",
      verifyvalue: "",
      verifyset: [],
      localitem: {},
      // remote接口调用五次失败后就显示失败
      countError: 0,
      nowRemoteInfo: {}
    };
  },
  mounted() {
    this.machineList.sort((a, b) => a.name.localeCompare(b.name));
    let _self = this;
    _self.initMap();
  },
  activated() {
    // Refresh data when component is activated (when navigating to this page)
    this.initMap();
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      // Refresh data when entering this route
      vm.initMap();
    });
  },
  computed: {
    machineListWithOperationType() {
      return this.machineList.map(row => ({
        ...row,
        operationType: row.location ? 'edit' : 'add'
      }));
    }
  },
  methods: {
    
    handleSortChange({ prop, order }) {
      if (prop === 'location') {
        if (order === 'ascending') {
          // 'No Address' at the top
          this.machineList.sort((a, b) => {
            if (!a.location && b.location) return -1;
            if (a.location && !b.location) return 1;
            return 0;
          });
        } else if (order === 'descending') {
          // 'No Address' at the bottom
          this.machineList.sort((a, b) => {
            if (!a.location && b.location) return 1;
            if (a.location && !b.location) return -1;
            return 0;
          });
        } else {
          // Reset to original order (by index)
          this.machineList.sort((a, b) => a.index - b.index);
        }
      } else if (prop === 'operationType') {
        if (order === 'ascending') {
          this.machineList.sort((a, b) => {
            const aType = a.location ? 'edit' : 'add';
            const bType = b.location ? 'edit' : 'add';
            return aType.localeCompare(bType);
          });
        } else if (order === 'descending') {
          this.machineList.sort((a, b) => {
            const aType = a.location ? 'edit' : 'add';
            const bType = b.location ? 'edit' : 'add';
            return bType.localeCompare(aType);
          });
        }
      }
    },
    testNotes() {
      let _self = this;
      _self.$api
        .request(_self.$url.Notes.test, _self.$method.get, {
          equipmentNo: _self.search.equipmentNo,
          equipmentName: _self.search.equipmentName
        })
        .then(res => {


        })
        .catch((err) => {


        });
    },
    addNotes(payLoad) {
      let _self = this;
      _self.$api
        .request(_self.$url.Notes.add, _self.$method.post, payLoad)
        .then(res => {
          if (res?.code === 0) {
            this.$message.success('Notes added successfully');
            // Refresh notes data specifically before closing dialog
            this.refreshNotesData();
            // Close dialog after a short delay to allow refresh
            setTimeout(() => {
              this.addressDialogVisible = false;
            }, 500);
          } else {
            this.$message.error(res.msg || 'Failed to add notes');
          }
        })
        .catch((err) => {
          this.$message.error('Failed to add notes: ' + (err.message || 'Unknown error'));
        });
    },
    async updateAddressByEquipmentNo(payLoad) {
      let _self = this;
      
      // Find the machine to get its ID
      const machine = this.machineList.find(m => m.machineNo === payLoad.machineNo);
      if (!machine) {
        return;
      }
      
      // Update the main machine data with coordinates for map display
      const machineUpdatePayload = {
        id: machine.machineId,
        teamId: machine.teamId,  // Preserve teamId to prevent machine group from being removed
        locale: payLoad.address,
        lat: payLoad.lat || '',  // Include coordinates for consistency
        lng: payLoad.lng || ''   // Include coordinates for consistency
      };
      
      // Also prepare notes update payload to sync with MachineUser.vue
      const notesUpdatePayload = {
        machineNo: payLoad.machineNo,
        machineId: machine.machineId,
        address: payLoad.address,
        lat: payLoad.lat || '',
        lng: payLoad.lng || '',
        contactName: payLoad.contactName || this.addressForm.Contact || 'N/A',
        phoneNumber: payLoad.phoneNumber || this.addressForm.PhoneNumber || '',
        email: payLoad.email || this.addressForm.email || '',
        notesContent: payLoad.notesContent || this.addressForm.Notes || '',
        installDate: payLoad.installDate || this.addressForm.Installed || ''
      };
      
      return Promise.all([
        _self.$api.request(_self.$url.UserMachine.update, _self.$method.put, machineUpdatePayload),
        _self.$api.request(_self.$url.Notes.updateByMachineNo, _self.$method.put, notesUpdatePayload)
      ])
        .then(([machineRes, notesRes]) => {
          if (machineRes?.code === 0 && notesRes?.code === 0) {
            const machineIndex = this.machineList.findIndex(machine => machine.machineNo === payLoad.machineNo);
            
            if (machineIndex !== -1) {
              // Update the machine list with new data
              this.$set(this.machineList, machineIndex, {
                ...this.machineList[machineIndex],
                location: payLoad.address,
                lat: payLoad.lat,
                lng: payLoad.lng
              });
              
              // Update the positions array immediately for map display
              const positionIndex = positions.findIndex(p => p.equipmentNo === payLoad.machineNo);
              if (positionIndex !== -1) {
                // Update existing position
                positions[positionIndex] = {
                  ...positions[positionIndex],
                  lat: payLoad.lat,
                  lng: payLoad.lng,
                  locale: payLoad.address
                };
              } else if (payLoad.lat && payLoad.lng) {
                // Add new position if it didn't exist before
                positions.push({
                  equipmentName: this.machineList[machineIndex].name,
                  equipmentNo: payLoad.machineNo,
                  lat: payLoad.lat,
                  lng: payLoad.lng,
                  locale: payLoad.address,
                  online: 1,
                  show: false
                });
              }
              
              // Force Vue to re-render the component
              this.$forceUpdate();
              
              // Immediately refresh the map markers to show the update
              _self.renderMapMarkers();
              
              // Also refresh the data from server after a short delay to ensure consistency
              setTimeout(() => {
                _self.initMap(); // Reload all machine data from server
              }, 1500);
            }
          }
        })
        .catch((err) => {
        });
    },

    initMap() {
      let _self = this;
      _self.$api
        .request(_self.$url.UserMachine.page, _self.$method.get, {
          equipmentNo: _self.search.equipmentNo,
          equipmentName: _self.search.equipmentName,
          pageIndex: 1,
          pageSize: 1000 // Get all machines for map display
        })
        .then(res => {
          positions = [];
          _self.showPositions = [];
          if (res.code === 0) {
            let totalpositions = res.data.records; // UserMachine.page returns {records: [...]}
            this.machineList = totalpositions.map((item, index) => ({
              name: item.equipmentName,
              machineNo: item.equipmentNo,
              machineId: item.machineId || item.id || '',
              teamId: item.teamId || '',  // Include teamId to preserve machine group
              index: index,
              location: item.locale || "",
              lat: item.lat || '',
              lng: item.lng || ''
            }));
            
            // Load notes data for all machines to get addresses - WAIT for it to complete
            _self.loadNotesForAllMachines().then(() => {
              // After notes are loaded, rebuild the positions array with updated coordinates
              positions = [];
              _self.showPositions = [];
              
              // Use the updated machineList which now has coordinates from notes
              for (let i = 0; i < _self.machineList.length; i++) {
                const machine = _self.machineList[i];
                let positionItem = {
                  equipmentName: machine.name,
                  equipmentNo: machine.machineNo,
                  lat: machine.lat,
                  lng: machine.lng,
                  locale: machine.location,
                  online: 1,
                  show: false
                };
                
                if (machine.lat && machine.lng) {
                  positions.push(positionItem);
                }

                if (_self.showPositions.length < _self.pageSize) {
                  _self.showPositions.push(positionItem);
                }
              }
              
              _self.count = positions.length;
              _self.pageIndex = 2;
              _self.rightLoading = false;
              
              // If map is already loaded, refresh the markers
              if (_self.mapInstance && _self.markerClusterer) {
                _self.renderMapMarkers();
              }
            });
            
            // Get current position information (latitude and longitude)
            if (navigator.geolocation) {
              navigator.geolocation.getCurrentPosition(
                function (position) {
                  _self.latitude = position.coords.latitude;
                  _self.longitude = position.coords.longitude;
                  _self.loadMaps(_self.latitude, _self.longitude);
                },
                function (error) {
                  let errorMessage;
                  switch (error.code) {
                    case error.PERMISSION_DENIED:
                      errorMessage = "Location permission denied by user";
                      break;
                    case error.POSITION_UNAVAILABLE:
                      errorMessage = "Location information unavailable";
                      break;
                    case error.TIMEOUT:
                      errorMessage = "Location request timed out";
                      break;
                    case error.UNKNOWN_ERROR:
                    default:
                      errorMessage = "An unknown error occurred while getting location";
                  }

                  // Default location (fallback) - USA center
                  let latitude = 39.8283;
                  let longitude = -98.5795;
                  _self.latitude = latitude;
                  _self.longitude = longitude;

                  // Show notification to user
                  _self.$notify({
                    title: 'Location Error',
                    message: errorMessage + '. Using default location.',
                    type: 'warning',
                    duration: 5000
                  });

                  _self.loadMaps(latitude, longitude);
                },
                {
                  enableHighAccuracy: true,
                  timeout: 10000,
                  maximumAge: 0
                }
              );
            }
          }
        })
        .catch(() => {
          _self.$notify({
            title: this.$t("common.tip"),
            message: "reqest error",
            type: "warning"
          });
        });
    },
    loadMaps(latitude, longitude, zoom = 3, equipmentNo = "") {
      let _self = this;
      const loader = new Loader({
        apiKey: "AIzaSyA1Rd3GCCRnoZU1dmTRgFZoRaLcsq13BOw", //已替换用户key
        version: "weekly", // 版本
        libraries: ["places"]
      });
      // 定位地图中心点
      let center = { lat: parseFloat(latitude), lng: parseFloat(longitude) };
      loader
        .load()
        .then(google => {
          const mapOptions = {
            disableDefaultUI: true, //禁用控件默认UI
            center: center,
            zoom: zoom,
            gestureHandling: "greedy", //鼠标缩放即可
            mapTypeId: "terrain",
            fullscreenControl: true,
            fullscreenControlOptions: {
              position: google.maps.ControlPosition.LEFT_TOP
            },
            streetViewControl: true,
            streetViewControlOptions: {
              position: google.maps.ControlPosition.LEFT_TOP
            }
          };
          let map = new google.maps.Map(document.getElementById("mapBox"), mapOptions);
          _self.mapInstance = map; // Store the map instance for later use
          // 向地图中心点添加（当前位置）标记
          if (parseInt(zoom) == 3) {
            marker = new google.maps.Marker({
              map: map,
              position: center,
              animation: google.maps.Animation.DROP,
              icon: {
                url: "/img/position.png", // url
                scaledSize: new google.maps.Size(50, 50)
              },
              optimized: true
            });
          } else {
            // 删除中心点
            marker.setMap(null);
          }
          // 向地图添加聚类标记
          const markers = positions.map(position => {
            const label = position.name;
            // 标记弹框内容{{$t('machine.equipmentNo')}}


            let contentString =
              '<div id="content" style="width: 250px;">' +
              '<div id="siteNotice"></div>' +
              '<h1 id="firstHeading" style="width: 100%;font-weight: 350; font-size: 22px; text-align: left; margin-bottom: 10px;">' +
              position.equipmentName +
              "</h1>" +
              '<p style="text-align: left;margin-bottom: 20px" class="popover-text-address">' + position.lat + '</p>' +
              '<div id="bodyContent" style="text-align: left;">' +
              '<div id="content">' +
              '<div style="display: flex; align-items: center; margin-bottom: 8px;">' +
              '<span class="profile-icon-bg"><i class="el-icon-s-custom" style="font-size: 28px; color: #FFFFFF;"></i></span>' +
              '<span style="font-size:14px;" class="popup-text-color">John Doe</span>' +
              '</div>' +
              '<div style="display: flex; align-items: center; margin-left:6px">' +
              '<i class="el-icon-phone" style="font-size:18px;color:#606060;margin-right:8px;"></i>' +
              '<span style="font-size:14px;"class="popup-text-color">+1 555-123-4567</span>' +
              '</div>' +
              '</div>' +
              '<div style="margin: 15px 0px;">' +
              "<span class='popover-text-address'>" +
              "This is notes lorem ipsum text random mill" +
              "</span></div>";

            const infowindow = new google.maps.InfoWindow({
              content: contentString,
              disableAutoPan: true
            });
            let newposition = {
              lat: parseFloat(position["lat"]),
              lng: parseFloat(position["lng"])
            };
            let icon = "/img/undfine.png";
            if (position.online) {
              if (parseInt(position.online) == 1) {
                icon = "/img/unline.png";
              } else if (parseInt(position.online) == 0) {
                icon = "/img/online.png";
              }
            }
            const marker = new google.maps.Marker({
              position: newposition,
              animation: google.maps.Animation.DROP,
              icon: {
                url: icon,
                scaledSize: new google.maps.Size(50, 50)
              }
            });
            if (parseInt(zoom) != 3 && equipmentNo == position.equipmentNo) {
              let djs = setTimeout(function () {
                clearTimeout(djs);
                infowindow.open({
                  anchor: marker,
                  map,
                  shouldFocus: false
                });
              }, 1000);
            }
            // 标记点击弹框事件
            marker.addListener("click", () => {
              // First fetch notes data for this machine
              _self.getNotesByMachineNo(position.equipmentNo).then(() => {
                // Update content string with the fetched data from addressForm
                let contentString =
                  '<div id="content" style="width: 250px;">' +
                  '<div id="siteNotice"></div>' +
                  '<h1 id="firstHeading" style="width: 100%;font-weight: 350; font-size: 22px; text-align: left; margin-bottom: 10px;">' +
                  position.equipmentName +
                  "</h1>" +
                  '<p style="text-align: left;margin-bottom: 20px" class="popover-text-address">' + _self.addressForm.location + '</p>' +
                  '<div id="bodyContent" style="text-align: left;">' +
                  '<div id="content">' +
                  '<div style="display: flex; align-items: center; margin-bottom: 8px;">' +
                  '<span class="profile-icon-bg"><i class="el-icon-s-custom" style="font-size: 28px; color: #FFFFFF;"></i></span>' +
                  '<span style="font-size:14px;" class="popup-text-color">' + (_self.addressForm.Contact || 'No Contact') + '</span>' +
                  '</div>' +
                  '<div style="display: flex; align-items: center; margin-left:6px">' +
                  '<i class="el-icon-phone" style="font-size:18px;color:#606060;margin-right:13px;"></i>' +
                  '<span style="font-size:14px;"class="popup-text-color">' + (_self.addressForm.PhoneNumber || 'No Phone') + '</span>' +
                  '</div>' +
                  '</div>' +
                  '<div style="margin: 15px 0px;">' +
                  "<span class='popover-text-address'>" +
                  (_self.addressForm.Notes || 'No Notes') +
                  "</span></div>";

                // Update infowindow content and open it
                infowindow.setContent(contentString);
                infowindow.open({ anchor: marker, map, shouldFocus: false });
              });
            });
            return marker;
          });
          _self.markerClusterer = new MarkerClusterer({ map, markers });
          _self.fullscreenLoading = false;
        })
        .catch(e => {
          _self.fullscreenLoading = false;
        });
    },

    async openAddressDialog(row) {
      // Initialize the address form with basic machine info
      this.addressForm = { 
        name: row.name, 
        location: row.location, 
        machineNo: row.machineNo,
        machineId: row.machineId || '',
        lat: row.lat || '',
        lng: row.lng || ''
      };
      this.selectedAddress = { name: row.name, location: row.location };
      
      // ALWAYS fetch the latest notes data from the server to ensure we have the most recent address
      // This is critical because the backend might have been updated by another user or process
      try {
        await this.getNotesByMachineNo(row.machineNo);
      } catch (error) {
        // Continue with the data we have if fetch fails
      }
      
      // No longer need editingIndex since we find by machineNo
      this.editingIndex = row.index; // Keep for backward compatibility if needed elsewhere

      this.addressSuggestions = [];

      this.addressDialogVisible = true;
      this.addressDialogAction = this.addressForm.location ? 'edit' : 'add';
    },
    getNotesByMachineId(id) {
      let _self = this;
      _self.$api
        .request(_self.$url.Notes.getByMachineId, _self.$method.get, {
          machineId: id
        })
        .then(res => {
          if (res?.code === 0 && res?.data?.id) {

            this.notesContentAction = 'edit';
            this.addressForm = {
              location: this.selectedAddress.location,
              notesId: res.data.id || '',
              Contact: res.data.contactName || '',
              PhoneNumber: res.data.phoneNumber || '',
              email: res.data.email || '',
              Notes: res.data.notesContent || '',
              Installed: res.data.installDate || ''
            };

          } else {
            this.notesContentAction = 'add';
            this.addressForm = {
              location: this.selectedAddress.location,
              Contact: '',
              PhoneNumber: '',
              email: '',
              Notes: '',
              Installed: ''
            };
          }

        })
        .catch((err) => {


        });

    },
    getNotesByMachineNo(machineNumber) {
      let _self = this;
      return _self.$api
        .request(_self.$url.Notes.getByMachineNo, _self.$method.get, {
          machineNo: machineNumber
        })
        .then(res => {
          if (res?.code === 0 && res?.data) {
            this.notesContentAction = 'edit';
            this.addressForm = {
              ...this.addressForm, // Preserve form data like name and machineNo
              notesId: res.data.id || '',
              machineId: res.data.machineId || this.addressForm.machineId || '',
              // CRITICAL: Use the address from notes data as it's the source of truth
              location: res.data.address || res.data.locale || this.addressForm.location || '',
              Contact: res.data.contactName || '',
              PhoneNumber: res.data.phoneNumber || '',
              email: res.data.email || '',
              Notes: res.data.notesContent || '',
              Installed: res.data.installDate || '',
              // Prioritize backend data for coordinates to ensure latest values are used
              lat: res.data.lat || this.addressForm.lat || '',
              lng: res.data.lng || this.addressForm.lng || ''
            };
          } else {
            this.notesContentAction = 'add';
            this.addressForm = {
              ...this.addressForm,
              location: this.selectedAddress.location || '',
              Contact: '',
              PhoneNumber: '',
              email: '',
              Notes: '',
              Installed: ''
              // Preserve lat/lng that were already set
            };
          }
          return Promise.resolve();
        })
        .catch((err) => {
          this.addressForm = {
            ...this.addressForm, // Preserve existing data including lat/lng
            location: this.selectedAddress.location || '',
            Contact: '',
            PhoneNumber: '',
            Notes: ''
          };
          return Promise.resolve();
        });
    },
    updateNotes(payLoad) {
      let _self = this;
      _self.$api
        .request(_self.$url.Notes.update, _self.$method.put, payLoad)
        .then(res => {
          if (res?.code === 0) {
            this.$message.success('Notes updated successfully');
            // Refresh notes data specifically before closing dialog
            this.refreshNotesData();
            // Close dialog after a short delay to allow refresh
            setTimeout(() => {
              this.addressDialogVisible = false;
            }, 500);
          } else {
            this.$message.error(res.msg || 'Failed to update notes');
          }
        })
        .catch((err) => {
          this.$message.error('Failed to update notes: ' + (err.message || 'Unknown error'));
        });
    },

    async loadNotesForAllMachines() {
      const promises = this.machineList.map(async (machine) => {
        try {
          const response = await this.$api.request(
            this.$url.Notes.getByMachineNo, 
            this.$method.get, 
            { machineNo: machine.machineNo }
          );
          
          if (response.code === 0 && response.data) {
            // Update the machine in the list with notes data - always use latest from database
            const machineIndex = this.machineList.findIndex(m => m.machineNo === machine.machineNo);
            if (machineIndex !== -1) {
              // Always use the latest address from the database
              const newAddress = response.data.address || response.data.locale || response.data.location || '';
              
              this.$set(this.machineList, machineIndex, {
                ...this.machineList[machineIndex],
                notesData: response.data,
                location: newAddress,
                lat: response.data.lat || this.machineList[machineIndex].lat,
                lng: response.data.lng || this.machineList[machineIndex].lng
              });
            }
          } else if (response.code === 0 && !response.data) {
            // If no notes data found, clear the location (address was deleted from database)
            const machineIndex = this.machineList.findIndex(m => m.machineNo === machine.machineNo);
            if (machineIndex !== -1) {
              this.$set(this.machineList, machineIndex, {
                ...this.machineList[machineIndex],
                location: null,
                notesData: null
              });
            }
          }
        } catch (error) {
        }
      });
      
      await Promise.all(promises);
      // Force Vue to re-render the component to show updated addresses
      this.$forceUpdate();
    },

    refreshNotesData() {
      // Refresh notes data after successful save
      if (this.addressForm.machineNo) {
        this.getNotesByMachineNo(this.addressForm.machineNo).then(() => {
          // Also update the machine list with the refreshed data
          this.loadNotesForAllMachines();
        });
      }
    },

    async refreshMachineDataFromServer(machineNo) {
      // Refresh specific machine data from server to get latest address
      const response = await this.$api.request(
        this.$url.UserMachine.page,
        this.$method.get,
        {
          equipmentNo: this.search.equipmentNo,
          equipmentName: this.search.equipmentName,
          pageIndex: 1,
          pageSize: 1000
        }
      );

      if (response.code === 0 && response.data.records) {
        // Find the specific machine in the response
        const updatedMachine = response.data.records.find(m => m.equipmentNo === machineNo);
        if (updatedMachine) {
          // Update the machine in our local list
          const machineIndex = this.machineList.findIndex(m => m.machineNo === machineNo);
          if (machineIndex !== -1) {
            this.$set(this.machineList, machineIndex, {
              name: updatedMachine.equipmentName,
              machineNo: updatedMachine.equipmentNo,
              machineId: updatedMachine.machineId || updatedMachine.id || '',
              teamId: updatedMachine.teamId || '', // Include teamId to preserve machine group
              index: machineIndex,
              location: updatedMachine.locale || "",
              lat: updatedMachine.lat || '',
              lng: updatedMachine.lng || '',
              notesData: this.machineList[machineIndex].notesData // Preserve notes data
            });
          }
        }
      }
    },

    async refreshMachineAddress(machineNo) {
      // Refresh the specific machine's address data from the server
      try {
        const response = await this.$api.request(
          this.$url.Notes.getByMachineNo, 
          this.$method.get, 
          { machineNo: machineNo }
        );
        
        if (response.code === 0 && response.data) {
          // Find the machine in our list and update its address
          const machineIndex = this.machineList.findIndex(machine => machine.machineNo === machineNo);
          
          if (machineIndex !== -1) {
            this.$set(this.machineList, machineIndex, {
              ...this.machineList[machineIndex],
              location: response.data.address || response.data.locale || "",
              lat: response.data.lat || this.machineList[machineIndex].lat,
              lng: response.data.lng || this.machineList[machineIndex].lng
            });
          }
        }
      } catch (error) {
      }
    },

    refreshMapMarkers() {
      // Refresh the map markers with updated coordinates
      // Update the positions array with current machine data
      positions = [];
      this.machineList.forEach(machine => {
        if (machine.lat && machine.lng) {
          positions.push({
            equipmentName: machine.name,
            equipmentNo: machine.machineNo,
            lat: machine.lat,
            lng: machine.lng,
            locale: machine.location,
            online: 1 // Default online status
          });
        }
      });
      
      // Re-render the map with new markers
      this.renderMapMarkers();
    },

    renderMapMarkers() {
      // Re-render map markers with current positions
      if (typeof google !== 'undefined' && google.maps && this.mapInstance) {
        let _self = this;
        
        // Clear existing markers
        if (this.markerClusterer) {
          this.markerClusterer.clearMarkers();
        }
        
        // Create new markers with proper infowindows
        const markers = positions.map(position => {
          const newposition = {
            lat: parseFloat(position.lat),
            lng: parseFloat(position.lng)
          };
          
          let icon = "/img/undfine.png";
          if (position.online) {
            if (parseInt(position.online) == 1) {
              icon = "/img/unline.png";
            } else if (parseInt(position.online) == 0) {
              icon = "/img/online.png";
            }
          }
          
          const marker = new google.maps.Marker({
            position: newposition,
            animation: google.maps.Animation.DROP,
            icon: {
              url: icon,
              scaledSize: new google.maps.Size(50, 50)
            }
          });
          
          // Create infowindow for this marker
          const infowindow = new google.maps.InfoWindow({
            disableAutoPan: true
          });
          
          // Add click listener to fetch fresh data and show
          marker.addListener("click", () => {
            // Fetch the latest notes data for this machine
            _self.getNotesByMachineNo(position.equipmentNo).then(() => {
              // Build content string with fresh data
              let contentString =
                '<div id="content" style="width: 250px;">' +
                '<div id="siteNotice"></div>' +
                '<h1 id="firstHeading" style="width: 100%;font-weight: 350; font-size: 22px; text-align: left; margin-bottom: 10px;">' +
                position.equipmentName +
                "</h1>" +
                '<p style="text-align: left;margin-bottom: 20px" class="popover-text-address">' + (_self.addressForm.location || position.locale || 'No Address') + '</p>' +
                '<div id="bodyContent" style="text-align: left;">' +
                '<div id="content">' +
                '<div style="display: flex; align-items: center; margin-bottom: 8px;">' +
                '<span class="profile-icon-bg"><i class="el-icon-s-custom" style="font-size: 28px; color: #FFFFFF;"></i></span>' +
                '<span style="font-size:14px;" class="popup-text-color">' + (_self.addressForm.Contact || 'No Contact') + '</span>' +
                '</div>' +
                '<div style="display: flex; align-items: center; margin-left:6px">' +
                '<i class="el-icon-phone" style="font-size:18px;color:#606060;margin-right:13px;"></i>' +
                '<span style="font-size:14px;"class="popup-text-color">' + (_self.addressForm.PhoneNumber || 'No Phone') + '</span>' +
                '</div>' +
                '</div>' +
                '<div style="margin: 15px 0px;">' +
                "<span class='popover-text-address'>" +
                (_self.addressForm.Notes || 'No Notes') +
                "</span></div>";
              
              infowindow.setContent(contentString);
              infowindow.open(_self.mapInstance, marker);
            });
          });
          
          return marker;
        });
        
        // Add markers to clusterer
        if (this.markerClusterer) {
          this.markerClusterer.addMarkers(markers);
        } else {
          // Create new clusterer if it doesn't exist
          this.markerClusterer = new MarkerClusterer({ map: this.mapInstance, markers });
        }
      }
    },

    async saveAddress() {
      if (!this.addressForm.location) {
        this.$message.warning('Please enter an address');
        return;
      }


      // If coordinates are missing, geocode the address
      let lat = this.addressForm?.lat || this.addressForm?.latitude || '';
      let lng = this.addressForm?.lng || this.addressForm?.longitude || '';
      
      
		if (!lat || !lng) {
			try {
				const coordinates = await this.geocodeAddress(this.addressForm.location);
				if (coordinates) {
					lat = coordinates.lat;
					lng = coordinates.lng;
				}
			} catch (error) {
				this.$message.warning('Could not get coordinates for the address. The address will be saved without map coordinates.');
			}
		}

      let addressPayload = {
        "machineNo": this.addressForm.machineNo,
        "address": this.addressForm?.location,
        "lng": lng,
        "lat": lat,
        // Include all the notes form data that user edited
        "contactName": this.addressForm.Contact || 'N/A',
        "phoneNumber": this.addressForm.PhoneNumber || '',
        "email": this.addressForm.email || '',
        "notesContent": this.addressForm.Notes || '',
        "installDate": this.addressForm.Installed || ''
      }
      
      
      try {
        await this.updateAddressByEquipmentNo(addressPayload);
        this.$message.success('Address and notes updated successfully');
        
        // Emit event to notify MachineUser.vue that address was updated
        eventBus.emit('machineAddressUpdated', {
          machineNo: this.addressForm.machineNo,
          machineId: this.addressForm.machineId,
          address: this.addressForm.location,
          lat: lat,
          lng: lng
        });
        
        this.addressDialogVisible = false;
      } catch (error) {
        this.$message.error('Failed to update address');
      }
    },

    // Geocode an address to get coordinates
    geocodeAddress(address) {
      return new Promise((resolve, reject) => {
        if (!address) {
          reject(new Error('No address provided'));
          return;
        }

        const loader = new Loader({
          apiKey: "AIzaSyA1Rd3GCCRnoZU1dmTRgFZoRaLcsq13BOw",
          version: "weekly",
          libraries: ["places"]
        });

        loader.load().then((google) => {
          const geocoder = new google.maps.Geocoder();
          
          geocoder.geocode({ address: address }, (results, status) => {
            if (status === google.maps.GeocoderStatus.OK && results && results.length > 0) {
              const location = results[0].geometry.location;
              const coordinates = {
                lat: location.lat(),
                lng: location.lng()
              };
              resolve(coordinates);
            } else {
              reject(new Error(`Geocoding failed: ${status}`));
            }
          });
        }).catch((error) => {
          reject(error);
        });
      });
    },

    querySearch(queryString, cb) {
      if (!queryString) {
        cb([]);
        return;
      }
      const loader = new Loader({
        apiKey: "AIzaSyA1Rd3GCCRnoZU1dmTRgFZoRaLcsq13BOw",
        version: "weekly",
        libraries: ["places"]
      });
      loader.load().then((google) => {
        const autocompleteService = new google.maps.places.AutocompleteService();
        const placesService = new google.maps.places.PlacesService(document.createElement('div'));
        autocompleteService.getPlacePredictions({
          input: queryString,
          types: ["establishment", "geocode"]
        }, (predictions, status) => {
          if (status !== google.maps.places.PlacesServiceStatus.OK || !predictions) {
            cb([]);
            return;
          }
          // For each prediction, fetch full address
          const fetchDetails = predictions.map(prediction => {
            return new Promise(resolve => {
              placesService.getDetails({ placeId: prediction.place_id, fields: ["name", "formatted_address", "address_components", "geometry"] }, (place, status) => {
                let county = "";
                let lat = "";
                let lng = "";
                if (status === google.maps.places.PlacesServiceStatus.OK && place) {
                  if (place.address_components) {
                    const countyComp = place.address_components.find(comp =>
                      comp.types.includes("administrative_area_level_2")
                    );
                    if (countyComp) {
                      county = countyComp.long_name;
                      county = county.replace(/\s*County$/i, "").trim();
                    }
                  }
                  if (place.geometry && place.geometry.location) {
                    lat = place.geometry.location.lat();
                    lng = place.geometry.location.lng();
                  }

                  resolve({ name: place.name, address: place.formatted_address, county, lat, lng });
                } else {
                  resolve({ name: prediction.structured_formatting.main_text, address: prediction.structured_formatting.secondary_text || prediction.description, county: "", lat: "", lng: "" });
                }
              });
            });
          });
          Promise.all(fetchDetails).then(results => {
            cb(results);
          });
        });
      });
    },
    handleAddressSelect(item) {
      this.addressForm.location = item.address;
      this.addressForm.lat = item.lat;
      this.addressForm.lng = item.lng;

    },
    clearAddress() {
      this.addressForm.location = '';
      this.addressSuggestions = [];
      // Hide autocomplete dropdown

      this.$nextTick(() => {
        const ac = this.$refs.addressAutocomplete;
        if (ac && ac.suggestionsVisible !== undefined) ac.suggestionsVisible = false;
      });
    },

    // Clean address to remove duplication pattern
    cleanAddress(address) {
      if (!address) return address;
      
      
      // Pattern to match: "Street Name, County, Street Name, City, State, ZIP, Country"
      // Example: "7921 Simon Ave, Cuyahoga, 7921 Simon Ave, Cleveland, OH 44103, USA"
      // More flexible pattern to handle various formats
      const duplicatePattern = /^(.+?),\s*([^,]+),\s*\1,\s*(.+)$/;
      const match = address.match(duplicatePattern);
      
      if (match) {
        // Return: "Street Name, City, State, ZIP, Country"
        const cleaned = `${match[1]}, ${match[3]}`;
        return cleaned;
      }
      
      return address;
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog {
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial,
    sans-serif;

  .el-dialog__header {
    padding: 10px 0px 15px 20px !important;
    border-bottom: unset !important;

  }

  .el-dialog__body {
    padding: 0px !important;
  }

  .el-dialog__footer {
    padding: 0px 0px 25px 0px !important;
    border-top: unset !important;
  }

  // .el-dialog__headerbtn .el-dialog__close {
  //   color: white;
  // }

  .el-dialog__title {
    color: white;
  }


  .el-form--label-top .el-form-item__label {
    padding: 0;
  }

  .el-form-item {
    margin: 0;
  }

  .el-dialog__headerbtn {
    top: 18px;
    right: 15px;
  }
}



::-webkit-scrollbar {
  width: 0 !important;
}

::-webkit-scrollbar {
  width: 0 !important;
  height: 0;
}

.el-drawer__wrapper {
  position: absolute;
  display: flow-root;
  margin: 0 26px;
}

.el-popover {
  line-height: 2.4;
}


.machine-address {
  position: absolute;
  z-index: 999;
  top: 25px;
  left: 25px;
  font-size: 10px !important;
  background-color: white;
}

::v-deep .el-table__body tr {
  height: 80px !important;
}

.text-danger {
  // color: #f56c6c;
  font-weight: bold;
}

::v-deep .location-dialog .el-dialog .el-dialog__header {
  background-color: unset !important;
}


.dialog-title-left {
  display: block;
  text-align: left;
  font-size: 22px;
  font-weight: 600;
  color: #333;
  padding-left: 4px;
}

.popup-form {
  margin-left: 50px;
  margin-right: 250px;
}

.popup-row {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}

.popup-label {
  /* font-weight: 600;
  font-size: 16px; */
  /* color: #555; */

  text-align: right;
  padding-right: 12px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.dialog-footer-left {
  display: flex;
  justify-content: flex-start;
  margin-left: 25%;
  gap: 12px;
}

.popup-field {
  /* font-size: 16px; */
  /* color: #222; */
  word-break: break-word;
  text-align: left;
}

.address-suggestion-dropdown {
  min-width: 350px;
}

.address-suggestion-item {
  display: flex;
  align-items: flex-start;
  /* align icon and text at the top */
  padding: 6px 10px;
}

.location-icon-bg {
  flex: 0 0 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f3f6fa;
  border-radius: 50%;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  margin-right: 10px;
}

.location-icon-bg .el-icon {
  font-size: 18px;
  color: #409EFF;
}

.suggestion-text {
  flex: 1;
  min-width: 0;
  overflow: hidden;
}

.suggestion-title,
.suggestion-address {
  display: -webkit-box;
  line-clamp: 1;
  -webkit-line-clamp: 1;
  /* max 2 lines */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
  white-space: normal;
  /* allow wrapping but clamp */
}

.suggestion-title {
  font-weight: 600;
  font-size: 14px;
  color: #222;
  margin-bottom: 2px;
  line-height: 1.4;
}

.suggestion-address {
  font-size: 12px;
  color: #666;
  line-height: 1.3;
}

.ip-icon {
  margin-top: 13px;
}

/* Hide the close button in Google Maps InfoWindow */
// .gm-ui-hover-effect {
//   display: none !important;
// }

.profile-icon-bg {
  background-color: #c7c7c7;
  margin-right: 8px;
  border-radius: 50%;
}

.popup-text-color {
  color: #747474 !important;
}

.popover-text-address {
  color: #857a7a !important;
}
</style>
